import actions from "./actions";

const initState = {
  reportsStatistics: [],
  loadingReportsStatistics: true,
};

export default function qrReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_REPORTS_STATISTICS_SUCCESS:
      return {
        ...state,
        reportsStatistics: action.reportsStatistics,
        loadingReportsStatistics: action.loadingReportsStatistics,
      };
    case actions.GET_REPORTS_STATISTICS_REQUEST:
      return {
        ...state,
        loadingReportsStatistics: true,
      };
    default:
      return state;
  }
}
